import dayjs from 'dayjs';
import type { EducationPlanSchedule } from 'services/api';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';

export const getColumns = (): AppTableColumn<EducationPlanSchedule>[] => {
  return [
    {
      key: 'id',
      title: 'Версия',
      dataIndex: ['id'],
      maxWidth: '50px',
    },
    {
      key: 'date',
      title: 'Дата создания',
      dataIndex: ['date'],
      render: (date: string) => dayjs(date).format('DD.MM.YYYY HH:mm:ss'),
    },
  ];
};
